<template>
  <div>
    <div class="h-dialogContainer" >
      <template>
        <ParseForm ref="basic" :formId="formItems.basic.formId" :formParams="formItems.basic.formObj" :opCode="opCode"></ParseForm>
      </template>    
    </div>
  </div>
</template>
<script>
import ParseForm from '../../../util/parseFormNew/ParseForm';
import CustomDialog from '../../../../common/CustomDialog';
import SubscriberTool from '../../../util/parseFormNew/tools/subscriberTool';
import ajaxUrl from "../../../data/ajaxUrl";

export default {
  name: "AddProfileForm",
  components: {
    ParseForm,
    CustomDialog,
  }, 
  methods: {
    getDatas() {
      const map = new Map();
      if (this.$refs.basic) {
        if (!this.$refs.basic.validateResult()) {
          console.log("表单验证不通过");
          return;
        }
        const maps = this.$refs.basic.getDatas();
        for (const [key, value] of maps.entries()) {
          map.set(key, value);
        }
      }    
      console.log(map);
      return map;
    },
    getJson(ne, callback) {  
      this.ne = ne;
      const params = {
        msgid: this.msgId,
        neid: ne.neid,
      };
      this.$axios.post(ajaxUrl.amdataJson, params).then(response => {
        if (!response) {
          console.log("getJson response error");
          return;
        }
        if (!response.data) {
          console.log("getJson response.data error");
          return;
        }
        if (!response.data.resultVal) {
          console.log("getJson response.data.resultVal error");
          return;
        }
        if (response.data.errorCode !== "0") {
          console.log("getJson response.data.errorCode error");
          callback(response);
          return;
        }
        const res = response.data.resultVal;  
                  console.log("res",res);

        const sub = new SubscriberTool();
        const resultMap = sub.$devideByGroupBy(res, []);
          console.log("resultMap",resultMap);

        this.formItems.basic.formObj = resultMap.get(this.formItems.basic.modelName);
        callback(response);
      });      
    },
    saveProfile(ne, callback) {
      const formData = this.getDatas();      
      if (formData) {    
        const params = { 
          vo: {
            "neid": ne.neid,
            "profileId": parseInt(formData.get("profileId")),
            "profileName": formData.get("profileName"),
            "ueAmbrUp": parseInt(formData.get("ueAmbrUp")),
            "ueAmbrDown": parseInt(formData.get("ueAmbrDown")),
          }, 
          info: {
            msgid: this.msgId,
            neid: ne.neid,
          }
        };
        console.log("params",params);
        this.$axios.post(ajaxUrl.requestCommonD, params).then((response) => {
          if (callback) {
            callback(response);
          }
        });
      } 
    }, 
  },
  computed: {
  },
  data() {
    return {      
      ne: null,
      selectedKeys: [],
      funcMap: null,
      formItems: {
        basic: {
          formId: "AmDataAddProfileInfo",
          modelName: "basic",
          formObj: null,
        },
      }, 
      opCode: "add",
      msgId: "28680",
    };
  },  
  beforeDestroy() {
  }
};
</script>
